/**
 * AdminRoutes.jsx — flattened route config voor admin-pages.
 *
 * Gebruikt React.createElement i.p.v. JSX om babel-metadata-plugin recursie
 * te omzeilen (stack-overflow op grote route-arrays).
 */
import React from 'react';
import { Route } from 'react-router-dom';
import { AdminRoute } from './ProtectedRoute';
import AdminLayout from './AdminLayout';

import AdminDashboard from '../pages/admin/AdminDashboard';
import TrafficPage from '../pages/admin/TrafficPage';
import AdminLeadsPage from '../pages/admin/LeadsPage';
import ClientsPage from '../pages/admin/ClientsPage';
import ClientDetailPage from '../pages/admin/ClientDetailPage';
import ContractsPage from '../pages/admin/ContractsPage';
import RevenuePage from '../pages/admin/RevenuePage';
import MeetingsAdminPage from '../pages/admin/MeetingsAdminPage';
import TasksPage from '../pages/admin/TasksPage';
import AuditPage from '../pages/admin/AuditPage';
import OrdersPage from '../pages/admin/OrdersPage';
import ManagedClientsPage from '../pages/admin/ManagedClientsPage';
import TestPanelPage from '../pages/admin/TestPanelPage';
import AiQueuePage from '../pages/admin/AiQueuePage';
import EmailHealthPage from '../pages/admin/EmailHealthPage';
import RollenbeheerPage from '../pages/admin/RollenbeheerPage';
import AdminTrialsPage from '../pages/admin/TrialsPage';
import AdminDiscountCodesPage from '../pages/admin/DiscountCodesPage';
import AdminCommissionsPage from '../pages/admin/CommissionsPage';
import AdminWebsiteRequestsPage from '../pages/admin/WebsiteRequestsPage';
import AdminStatsPage from '../pages/admin/StatsPage';
import AdminAffiliatesPage from '../pages/admin/AffiliatesPage';
import AdminAuditLogPage from '../pages/admin/AuditLogPage';
import OpsTicketsPage from '../pages/admin/OpsTicketsPage';
import TemplatesPage from '../pages/admin/TemplatesPage';
import CrmPipelinePage from '../pages/admin/CrmPipelinePage';
import InvoicesPage from '../pages/admin/InvoicesPage';
import EmployeesPage from '../pages/admin/EmployeesPage';
import ReconciliationPage from '../pages/admin/ReconciliationPage';
import CustomerProfilePage from '../pages/admin/CustomerProfilePage';
import PartnerApplicationsPage from '../pages/admin/PartnerApplicationsPage';
import AdminSettingsPage from '../pages/admin/AdminSettingsPage';
import EmailDeliverabilityPage from '../pages/admin/EmailDeliverabilityPage';
import PaymentRecoveriesPage from '../pages/admin/PaymentRecoveriesPage';

const ce = React.createElement;

const ROUTES = [
  ['/admin', AdminDashboard],
  ['/admin/traffic', TrafficPage],
  ['/admin/leads', AdminLeadsPage],
  ['/admin/clients', ClientsPage],
  ['/admin/clients/:id', ClientDetailPage],
  ['/admin/contracts', ContractsPage],
  ['/admin/revenue', RevenuePage],
  ['/admin/meetings', MeetingsAdminPage],
  ['/admin/tasks', TasksPage],
  ['/admin/audit', AuditPage],
  ['/admin/orders', OrdersPage],
  ['/admin/managed', ManagedClientsPage],
  ['/admin/test-panel', TestPanelPage],
  ['/admin/ai-queue', AiQueuePage],
  ['/admin/email-health', EmailHealthPage],
  ['/admin/rollenbeheer', RollenbeheerPage],
  ['/admin/trials', AdminTrialsPage],
  ['/admin/discount-codes', AdminDiscountCodesPage],
  ['/admin/commissies', AdminCommissionsPage],
  ['/admin/website-aanvragen', AdminWebsiteRequestsPage],
  ['/admin/statistieken', AdminStatsPage],
  ['/admin/affiliates', AdminAffiliatesPage],
  ['/admin/audit-log', AdminAuditLogPage],
  ['/admin/ops-tickets', OpsTicketsPage],
  ['/admin/templates', TemplatesPage],
  ['/admin/crm', CrmPipelinePage],
  ['/admin/invoices', InvoicesPage],
  ['/admin/employees', EmployeesPage],
  ['/admin/reconcile', ReconciliationPage],
  ['/admin/customers/:id', CustomerProfilePage],
  ['/admin/partner-applications', PartnerApplicationsPage],
  ['/admin/settings', AdminSettingsPage],
  ['/admin/email-deliverability', EmailDeliverabilityPage],
  ['/admin/payment-recoveries', PaymentRecoveriesPage],
];

export const adminRoutes = ROUTES.map(([path, Page]) =>
  ce(Route, {
    key: path,
    path,
    element: ce(AdminRoute, null, ce(AdminLayout, null, ce(Page))),
  })
);
